import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { theme } from './assets/css/theme';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './assets/css/GlobalStyle';
import {
  AdminPageUrl,
  DiagnosisPageUrl,
  FindIdPageUrl,
  FindPasswordPageUrl,
  LoginPageUrl,
  MyPageUrl,
  NoticePageUrl,
  PrivacyInfoPageUrl,
  PrivacyPolicyPageUrl,
  ResultIdPageUrl,
  ResultPasswordPageUrl,
  SignupPageUrl,
  StuffPageUrl,
} from './url/poenUrl'; // URL들을 불러오기
import LoginPage from './pages/auth/LoginPage';
import FindIdPage from './pages/auth/FindIdPage';
import FindPasswordPage from './pages/auth/FindPasswordPage';
import ResultIdPage from './pages/auth/ResultIdPage';
import ResultPasswordPage from './pages/auth/ResultPasswordPage';
import SignupPage from './pages/auth/SignupPage';
import StuffPage from './pages/StuffPage';
import NoticePage from './pages/NoticePage';
import DiagnosisPage from './pages/DiagnosisPage';
import AdminPage from './pages/AdminPage';
import MyPage from './pages/MyPage';
import 'react-toastify/dist/ReactToastify.css';
import PrivacyPolicyPage from './pages/auth/PrivacyPolicyPage';
import PrivacyInfoPage from './pages/auth/PrivacyInfoPage';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Routes>
        {/* 관리자 페이지 라우팅 */}
        <Route path={LoginPageUrl} element={<LoginPage />} />
        <Route path={SignupPageUrl} element={<SignupPage />} />
        <Route path={PrivacyPolicyPageUrl} element={<PrivacyPolicyPage />} />
        <Route path={PrivacyInfoPageUrl} element={<PrivacyInfoPage />} />
        <Route path={FindIdPageUrl} element={<FindIdPage />} />
        <Route path={ResultIdPageUrl} element={<ResultIdPage />} />
        <Route path={FindPasswordPageUrl} element={<FindPasswordPage />} />
        <Route path={ResultPasswordPageUrl} element={<ResultPasswordPage />} />
        <Route path={StuffPageUrl} element={<StuffPage />} />
        <Route path={NoticePageUrl} element={<NoticePage />} />
        <Route path={DiagnosisPageUrl} element={<DiagnosisPage />} />
        <Route path={MyPageUrl} element={<MyPage />} />
        <Route path={AdminPageUrl} element={<AdminPage />} />
      </Routes>
    </ThemeProvider>
  );
};

export default App;
